import React, { useEffect, useState } from "react"
import { change, Field, isDirty, reset, resetSection } from "redux-form"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import {
  CheckboxField,
  LocationAutocomplete,
  MultipleSelectField,
  PhoneField,
  SingleSelectField,
  TextField,
} from "components/RenderInput"
import "components/style.scss"
import { assignEventToCategory } from "store/actions"
import { connect } from "react-redux"
import { FORM_NAMES } from "constants/index"
import UnsavedAlertModal from "components/UnsavedAlertModal"

const DetailsTab = ({
  businessUnits,
  categories,
  assignEventToCategory,
  isDirty,
  tabIsActive,
  resetForm,
  handleSave,
  change,
  selectedEvent,
  vendorId,
}) => {
  const [showAlertModal, setShowAlertModal] = useState(false)

  useEffect(() => {
    if (!tabIsActive && isDirty) {
      setShowAlertModal(true)
    }
  }, [tabIsActive])

  return (
    <React.Fragment>
      <Card>
        <CardHeader>
          <h4>Details</h4>
        </CardHeader>
        <CardBody>
          <Row className="my-3">
            <Col xs={12} md={4} sm={6} lg={4}>
              Name:
            </Col>
            <Col xs={12} md={8} sm={6} lg={8}>
              <Field
                name="name"
                component={TextField}
                placeholder="Experience Name"
              />
            </Col>
          </Row>
          <Row className="my-3 justify-content-end">
            <Col xs={12} md={8} sm={6} lg={8}>
              <Field
                name="hideName"
                component={CheckboxField}
                label="Hide name from experience thumbnail"
              />
            </Col>
          </Row>
          <Row className="my-3">
            <Col xs={12} md={4} sm={6} lg={4}>
              Assign to Business Unit:
            </Col>
            <Col xs={12} md={8} sm={6} lg={8}>
              <Field
                name="businessUnit"
                isSearchable={false}
                fullWidth={true}
                component={SingleSelectField}
                placeholder="No business unit"
                options={[
                  { value: null, label: "No business unit" },
                  ...businessUnits.map(bu => ({
                    value: bu.id,
                    label: bu.name,
                  })),
                ]}
              />
            </Col>
          </Row>
          <Row className="my-3">
            <Col xs={12} md={4} sm={6} lg={4}>
              Address (optional)
            </Col>
            <Col xs={12} md={8} sm={6} lg={8}>
              <Field
                name="address.address"
                component={LocationAutocomplete}
                placeholder="Please add an address if you are using the search by location feature"
                updateLat={value => change("setup.address.lat", value)}
                updateLng={value => change("setup.address.lng", value)}
              />
            </Col>
          </Row>
          <Row className="my-3">
            <Col xs={12} md={4} sm={6} lg={4}>
              Phone (optional)
            </Col>
            <Col xs={12} md={8} sm={6} lg={8}>
              <Field
                name="phone"
                component={PhoneField}
                placeholder="Phone Number"
              />
            </Col>
          </Row>
          <Row className="my-3">
            <Col xs={12} md={4} sm={6} lg={4}>
              Category:
            </Col>
            <Col xs={12} md={8} sm={6} lg={8}>
              <Field
                name="category"
                component={MultipleSelectField}
                disabled={!selectedEvent}
                options={categories.map(category => ({
                  value: category.id,
                  label: category.name,
                }))}
                placeholder="Select one or more categories"
                onChange={(event, newValue) => {
                  assignEventToCategory({
                    categories: newValue,
                    event_id: selectedEvent.id,
                    vendor_id: vendorId,
                  })
                }}
              />
            </Col>
          </Row>
        </CardBody>
      </Card>
      <UnsavedAlertModal
        isOpen={showAlertModal}
        onClose={() => {
          setShowAlertModal(false)
          resetForm()
        }}
        onSave={() => {
          handleSave()
          setShowAlertModal(false)
        }}
      />
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  selectedEvent: state.experiences.selectedEvent,
  vendorId: state.Login.vendorId,
  businessUnits: state.businessUnits.businessUnits || [],
  categories: state.Categories.categories,
  isDirty: isDirty(FORM_NAMES.EXPERIENCE)(
    state,
    ...[
      "setup.name",
      "setup.businessUnit",
      "setup.address",
      "setup.phone",
      "setup.category",
      "setup.hideName",
    ]
  ),
})

const mapDispatchToProps = dispatch => ({
  assignEventToCategory: values => dispatch(assignEventToCategory(values)),
  resetForm: () => dispatch(resetSection(FORM_NAMES.EXPERIENCE, ...["setup"])),
  change: (field, value) =>
    dispatch(change(FORM_NAMES.EXPERIENCE, `${field}`, value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(DetailsTab)
